import RuntimeConfig from '../model/RuntimeConfig'

const commonApiGateway = 'https://masecare-customer-mm.mocklab.io'

const localRuntimeConfig: RuntimeConfig = {
  ssrSharedCache: false,
  brandName: 'B2C',
  salesChannel: 'webLLY',
  apiGateway: commonApiGateway,
  defaultFeatureFlags: {
    isInitializedUserConfigCat: false,
    isLoginActive: true,
    isPermissionsActive: true,
  },
  configCatSDKKey: 'SyLYCI3UakmOim9hszs9jA/7Hx5eWenTkqB07hfqjALmw',
  authn: {
    clientId: 'z8svn21MBbjtpnt5WXh6',
    apiGateway: 'https://authn.sta.masstack.com/v1',
  },
  analytics: {
    GTMCode: 'GTM-XXXXXX',
    externalConfigName: 'b2c-care',
    siteName: 'MAS CARE',
  },
  redisUrl: 'redis://localhost:6379/2',
  environment: 'local',
  supportedLocales: ['es', 'en'],
  defaultLocale: 'es',
  salesHost: 'https://mas-sales-front.dev.k8s.masmovil.com',
  energyHost: 'https://manage.masmovilenergia.blue',
}

export default localRuntimeConfig
